// extracted by mini-css-extract-plugin
export var copyableItem = "_45-0";
export var underlined = "_45-1";